import { render, staticRenderFns } from "./ModuleInfo.vue?vue&type=template&id=38d7b40a&"
import script from "./ModuleInfo.vue?vue&type=script&lang=js&"
export * from "./ModuleInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModuleInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports